import { ObjectValues } from 'types';
import utils from 'utils';

export const RESIZED_WIDTH = {
  100: '100',
  240: '240',
  320: '320',
  480: '480',
  576: '576',
  720: '720',
  768: '768',
  1024: '1024',
  1080: '1080',
  1280: '1280',
  1920: '1920',
} as const;

export type ResizedWidth = ObjectValues<typeof RESIZED_WIDTH>;

export function getImgUrl(url: string, width?: ResizedWidth) {
  if (!url) return undefined;

  return utils.appendUrlParams(url, {
    width,
    format: 'auto',
  });
}
